/* hgn-side-cart-kit-cta.js — moved verbatim from snippets/hgn-side-cart-kit-cta.liquid on 2026-09-14 (page-weight:
   inline JS → theme asset, loaded synchronously at the same position so execution order
   and DOMContentLoaded timing are unchanged). EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';
  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  var HGNSideCart = B.HGNSideCart;

  /* ─────── Mid-build foot (audit 2026-08-12) ───────
     1-4 picks = nothing purchasable, yet the foot rendered "SUBTOTAL
     £0.00" above a live CHECKOUT that dead-ends on Shopify's empty
     cart. New rule: the checkout row NEVER renders over a zero-value
     basket. It returns the instant there is something to buy — real
     cart lines, or a ready kit (the virtual kit basket one-tap kit
     checkout sells). In the gap the kit's next step takes the space.
     _syncCheckoutLabel / _emptyKitFootState / _virtualKitBasket
     (kit-checkout cluster) untouched — this only picks WHICH row
     shows. */
  HGNSideCart.prototype._kitBuildStatus = function () {
    var TIER_LABELS = {
      classic:     'Classic Starter Kit',
      gels:        'Gel Starter Kit',
      'press-ons': 'Press-On Starter Kit'
    };
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (!kp || typeof kp.read !== 'function') return null;
      var st = kp.read();
      var tier = st && st.activeKit;
      if (!tier) return null;
      /* A market-disabled tier can't be finished here. */
      if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(tier)) return null;
      var kit = st.kits && st.kits[tier];
      var picks = (kit && kit.items && kit.items.length) || 0;
      if (picks <= 0) return null;
      var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
        { classic: 5, gels: 3, 'press-ons': 3 };
      var minimum = parseInt(minimums[tier], 10) || 0;
      if (minimum <= 0) return null;
      var remaining = minimum - picks;
      if (remaining <= 0) return null; /* at minimum — virtual kit basket owns the foot */
      return {
        tier:      tier,
        label:     TIER_LABELS[tier] || 'Starter Kit',
        picks:     picks,
        minimum:   minimum,
        remaining: remaining
      };
    } catch (e) { return null; }
  };

  /* Canonical "keep picking" destination. Mirrors `modeABuildHref` in
     hgn-starter-kit-selector — `maybeBootFromUtm()` in collection-chrome
     reads the params and lands the shopper in build mode on the tier. */
  HGNSideCart.prototype._kitPickHref = function (tier) {
    var base = (window.HGN_KIT_URLS && window.HGN_KIT_URLS[tier]) ||
               (window.HGN_KIT_URLS && window.HGN_KIT_URLS.all_kits) ||
               '/collections/all';
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + 'hgn_kit=1&hgn_kit_focus=' + encodeURIComponent(tier);
  };

  /* `show` true → kit CTA replaces the checkout row. Idempotent; safe
     to call on every render. */
  HGNSideCart.prototype._renderMidBuildFoot = function (show) {
    var self = this;
    if (!this.kitCtaEl) return;
    if (!show) {
      this.kitCtaEl.hidden = true;
      if (this.totalsEl)    this.totalsEl.hidden    = false;
      if (this.checkoutBtn) this.checkoutBtn.hidden = false;
      if (this.taxesEl)     this.taxesEl.hidden     = false;
      return;
    }
    var st = this._kitBuildStatus();
    if (!st) { this._renderMidBuildFoot(false); return; }
    /* MERGE (A1 x A4): the mint gate can leave the CTA armed on
       "Continue without discount" with its note showing. If the
       shopper then empties the cart down to a below-minimum kit, that
       note would hang over a kit CTA it no longer describes. Swapping
       the row out retires the verdict; the next real checkout earns a
       fresh mint attempt. */
    if (this._checkoutMintFailed) {
      this._checkoutMintFailed = false;
      this._mintFailedSig = null;
      if (this._clearCheckoutNote) this._clearCheckoutNote();
      if (this._syncCheckoutLabel) this._syncCheckoutLabel();
    }
    /* Hide, never disable — a greyed-out CHECKOUT still reads as "your
       basket is worth nothing". Taxes small print goes with it. */
    if (this.totalsEl)    this.totalsEl.hidden    = true;
    if (this.checkoutBtn) this.checkoutBtn.hidden = true;
    if (this.taxesEl)     this.taxesEl.hidden     = true;
    this.kitCtaEl.hidden = false;
    this.kitCtaEl.setAttribute('data-tier', st.tier);
    if (this.kitCtaLabelEl) {
      this.kitCtaLabelEl.textContent =
        'Pick ' + st.remaining + ' more design' + (st.remaining === 1 ? '' : 's');
    }
    if (this.kitCtaSubEl) {
      this.kitCtaSubEl.textContent =
        st.picks + ' of ' + st.minimum + ' picked · ' + st.label;
    }
    if (!this._kitCtaBound) {
      this._kitCtaBound = true;
      this.kitCtaEl.addEventListener('click', function () {
        var tier = self.kitCtaEl.getAttribute('data-tier');
        if (!tier) return;
        var href = self._kitPickHref(tier);
        /* Already on this collection — reloading under them is worse
           than just closing the drawer so they carry on picking. */
        var samePage = false;
        try {
          var target = new URL(href, window.location.origin);
          samePage = target.pathname === window.location.pathname;
        } catch (e) {}
        if (samePage) {
          if (typeof self.close === 'function') self.close();
          return;
        }
        window.location.href = href;
      });
    }
  };

  /* Empty-state kit CTA gate. The empty state gates on the ACTIVE
     tier, so a ready kit parked on a non-active tier can slip through —
     and one-tap kit checkout owns that shopper. Don't invite them to
     start a second kit on top of a finished one. */
  HGNSideCart.prototype._renderEmptyKitCta = function () {
    if (!this.emptyKitCtaEl) return;
    var readyKit = null;
    try {
      if (typeof this._emptyKitFootState === 'function') readyKit = this._emptyKitFootState();
    } catch (e) { readyKit = null; }
    this.emptyKitCtaEl.hidden = !!readyKit;
  };
})();
